<template>
  <v-tooltip v-if="!hideNewsBookmarks" color="fin-color-accent-red" top>
    <template #activator="{ on }">
      <v-btn
        :class="contentClass"
        :style="contentStyle"
        @click.prevent=" active = !active"
        color="fin-color-primary-dark"
        icon
        v-on="on">
        <v-icon v-if="active">icon-bookmark-filled</v-icon>
        <v-icon v-else>icon-bookmark</v-icon>
      </v-btn>
    </template>
    <span v-if="active">Von Bookmarks entfernen</span>
    <span v-else>Zu Bookmarks hinzufügen</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'fin-bookmark-btn',
  props: {
    contentClass: {
      type: String
    },
    contentStyle: {
      type: String
    }
  },
  data () {
    return {
      active: false,
      hideNewsBookmarks: process.env.VUE_APP_HIDE_NEWS_ALL === 'true' || process.env.VUE_APP_HIDE_NEWS_BOOKMARKS === 'true',
    }
  }
}
</script>
